import React, { Component } from 'react';
import b from 'b_';
import { inject, observer } from 'mobx-react';
import { RULE_REC_TYPE } from '../../../../constants';
import { saasIsolationLicense } from '../../../../productLicense';
import PolicyStore from '../../../../stores/Policy/PolicyStore';
import FileThreatRuleName from './FileThreatRuleName';
import FileRules from '../FileRules';
import { Card, FTBody, FTHeading } from '../../../Fuse';
import StackL from '../../../Spacers/Spacers';
import { TStrong } from '../../../Text/Text';
import { FuseConsoleCardFooter } from '../../../ConsoleFragments';
import ConsoleStore from '../../../../stores/ConsoleStore';
import './FileThreatRules.css';

const block = b.lock('FileThreatRules');

class FileThreatRules extends Component {
    static propTypes = {
        policy: PolicyStore.PropType.isRequired,
        console: ConsoleStore.PropType.isRequired,
    };

    renderAboutSection = () => {
        const isBrowserEmailIso = this.props.console.hasBrowserOrEmailLicense();

        return <Card title="What are File Threat Rules?">
            {isBrowserEmailIso ?
                <FTBody>
                    File Threat Rules can either block or allow uploads and downloads in Isolation based on specific
                    criteria designed to mitigate threat risks, such as when malware is detected in a file a user has
                    requested to download. These rules can also be configured to offer file previews even when
                    downloads are blocked.
                </FTBody> : <FTBody>
                    File Threat Rules can provide Isolated previews of blocked file downloads in Isolation.
                </FTBody>}
            <StackL />
            <FTHeading>When are File Threat Rules Applied?</FTHeading>
            <StackL />
            <FTBody>
                If a Content Rule does not block the site and the system determines the URL request is an
                upload or download, your File Threat Rules will be evaluated. The highest-ranking
                File Threat Rule that matches will be applied.
            </FTBody>
            <StackL />
            <FTHeading>How to Use File Threat Rules</FTHeading>
            <StackL />
            <FTBody><TStrong>Step 1. Edit the Default File Threat Rule</TStrong></FTBody>
            <StackL />
            <FTBody>
                This establishes the baseline file settings for all {isBrowserEmailIso ? 'uploads and' : 'blocked'}
                downloads in Isolation. The Default File
                Threat Rule applies to all files, is always enabled, and always operates at the lowest priority.
            </FTBody>
            <StackL />
            <FTBody><TStrong>Step 2. Add new File Threat Rules</TStrong></FTBody>
            <StackL />
            <FTBody>
                Name the Rule, then specify its Match Criteria and Action. This is how you create exceptions to the
                Default File Threat Rule.
            </FTBody>
            <StackL />
            <FTBody><TStrong>Step 3. Stack-rank File Threat Rules in the Console</TStrong></FTBody>
            <StackL />
            <FTBody>
                Rules are applied based on priority. Only the highest-ranking Rule with matching criteria is applied.
                This allows you to create Rules with specific exemptions that will override more broad Rules.
            </FTBody>
            <StackL />
            <FTHeading>Common Use Case</FTHeading>
            <StackL />
            {isBrowserEmailIso ? <FTBody>
                <span className={block('Bullet')}>•</span> Allow file uploads only to specific sites.<br />
                <span className={block('Bullet')}>•</span> Block all downloads that contain a malicious threat.<br />
                <span className={block('Bullet')}>•</span> Prevent all uploads and downloads for risky users.
            </FTBody> : <FTBody>
                Provide an Isolated preview of a blocked file in Isolation.
            </FTBody>}
            <StackL />
            <FuseConsoleCardFooter
                text={`If no File Threat Rules are added, the system assigns the default File
                Threat Rule for all uploads and downloads.`}
            />
        </Card>;
    }

    render() {
        return <FileRules
            showPreviewAction
            showMalwareCondition
            // Page is hidden from the menu, but in case someone access it directly.
            // Disable because SAAS users can not use or access our FTR rules.
            readOnly={this.props.console.license === saasIsolationLicense}
            scanFileSize={30}
            fileScanType={'threat'}
            scanLabel={'Threat Scan'}
            store={this.props.policy.fileThreatRules}
            itemNameFull={'File Threat Rule'}
            ruleType={RULE_REC_TYPE.FILE_THREAT_RULES}
            renderName={({ name, isDefault }) => <FileThreatRuleName name={name} isDefault={isDefault} />}
            sourceCountriesName={'File Source'}
        >
            {this.renderAboutSection()}
        </FileRules>;
    }
}

export default inject('policy', 'console')(observer(FileThreatRules));
